/**
 * @module survey_types
 */
import { createReducer } from '@reduxjs/toolkit';
import { questionLogicActions } from '~/behaviors/actions/question_logic.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeQuestionLogics = (state, action) => {
  const questionLogics = action?.payload?.entities?.questionLogics || {};
  Object.values(questionLogics).forEach((questionLogic) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[questionLogic.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[questionLogic.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...questionLogic,
    };
  });
};

const regenerateQuestionLogics = (state, action) => {
  const surveyId = action?.payload?.surveyId;
  const mainSurveyElementId = action?.payload?.mainSurveyElementId;
  const questionLogics = action?.payload?.entities?.questionLogics || {};

  if (!surveyId || !mainSurveyElementId) return state;

  const cleanedState = {};
  Object.keys(state).forEach((id) => {
    const logic = state[id];
    if (logic.surveyId !== surveyId || logic.mainSurveyElementId !== mainSurveyElementId) {
      cleanedState[id] = logic;
    }
  });

  Object.values(questionLogics).forEach((questionLogic) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    cleanedState[questionLogic.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...cleanedState[questionLogic.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...questionLogic,
    };
  });

  return cleanedState;
};

const removeQuestionLogics = (state, action) => {
  const surveyId = action?.payload?.surveyId;
  const mainSurveyElementId = action?.payload?.mainSurveyElementId;

  if (!surveyId || !mainSurveyElementId) return state;

  const newState = {};
  Object.keys(state).forEach((id) => {
    const logic = state[id];
    if (logic.surveyId !== surveyId || logic.mainSurveyElementId !== mainSurveyElementId) {
      newState[id] = logic;
    }
  });
  return newState;
};

const questionLogics = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(questionLogicActions.getQuestionLogics.fulfilled, mergeQuestionLogics);
  builder.addCase(questionLogicActions.createQuestionLogic.fulfilled, mergeQuestionLogics);

  builder.addCase(questionLogicActions.updateQuestionLogic.fulfilled, regenerateQuestionLogics);

  builder.addCase(questionLogicActions.deleteQuestionLogic.fulfilled, removeQuestionLogics);
});

export default questionLogics;
